import { Request } from '../../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import {IPrepExtensionsServerSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';

export interface IGetPrepExtensionsServerSettingsParams {}

export type IGetPrepExtensionsServerSettingsResult = IResult & IPrepExtensionsServerSettings;

export class GetPrepExtensionsServerSettingsRequest extends Request<IGetPrepExtensionsServerSettingsParams, IGetPrepExtensionsServerSettingsResult> {
  constructor(params: IGetPrepExtensionsServerSettingsParams) {
    super('getPrepExtensionsServerSettings', params);
  }
}
